exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-allcontacts[data-v-c28817ba]{.overflow-contacts{height:394px;overflow-y:scroll}ul{list-style:none}li{padding:10px;border-bottom:1px solid #ccc;width:343px;cursor:pointer}li:hover{background-color:#eaeaea}li:before{content:\"\"}}.loader[data-v-c28817ba]{height:425px;padding:45%}.search-input[data-v-c28817ba]{margin:0!important}.contacts[data-v-c28817ba]{position:relative;.no-contacts{padding:3rem 1.5rem;background-color:#fff;i{display:block;font-size:5rem;margin-bottom:1rem}h2,i{color:#243153;text-align:center}h2{font-size:1.5rem}span{display:block;text-align:center}}.contacts{background-color:#fff;height:425px;overflow-y:auto;padding:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c28817ba","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/ContactsTab.vue
// module id = Ar/m
// module chunks = 0